<script setup>
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const { t } = useI18n();
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-1.5 py-0.5 text-[0.6875rem] font-medium leading-none rounded-md bg-n-blue-3 text-n-blue-11 shrink-0"
    :title="t('WHATSAPP_TEMPLATES.SEGUROCOR.SYSTEM_BADGE_TOOLTIP')"
  >
    <Icon icon="i-lucide-badge-check" class="size-3" />
    {{ t('WHATSAPP_TEMPLATES.SEGUROCOR.SYSTEM_BADGE') }}
  </span>
</template>
